import { useCallback, useEffect, useState } from "react";
import { PettyWorkStatus } from "features/PettyWorks/constants/petty-work.constants";
import { getPettyWorks } from "features/PettyWorks/services/PettyWorkService";

export type UseReadyForBillingPettyWorkCountResult = {
  count: number;
  isLoading: boolean;
  refetch: () => void;
};

export function useReadyForBillingPettyWorkCount(
  enabled: boolean,
): UseReadyForBillingPettyWorkCountResult {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [tick, setTick] = useState(0);

  const refetch = useCallback(() => {
    setTick((t) => t + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    void (async () => {
      try {
        const res = await getPettyWorks({
          page: 1,
          limit: 1,
          status: PettyWorkStatus.READY_FOR_BILLING,
        });
        if (cancelled) return;
        if (res.success && res.data) {
          const total = Number(res.data.totalItems);
          setCount(Number.isFinite(total) && total > 0 ? total : 0);
        } else {
          setCount(0);
        }
      } catch {
        if (!cancelled) setCount(0);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled, tick]);

  return { count, isLoading, refetch };
}
